export default "__VITE_ASSET__29359948__"